import { combineReducers } from 'redux';
import user from './reducer_user';

const appReducer = combineReducers({
  user
});

export const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    state = undefined
  }

  return appReducer(state, action)
}




// WEBPACK FOOTER //
// ./src/reducers/index.js